import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { UserComponent } from './user.component';
import { ProfileComponent } from './profile/profile.component';
import { ChangePasswordProfileComponent } from './change-password-profile/change-password-profile.component';
import { RequestSupportComponent } from './request-support/request-support.component';
import { LogoutComponent } from './logout/logout.component';
import { NoAuthGuardService } from '../../shared/guards';

const routes: Routes = [{
  path: '',
  component: UserComponent,
  children: [
    {
      path: 'profile',
      component: ProfileComponent,
    },
    {
      path: 'changePassword',
      component: ChangePasswordProfileComponent,
    },
    {
      path: 'supportRequest',
      component: RequestSupportComponent,
    },
    {
      path: 'logout',
      component: LogoutComponent,
     
    },
    {
      path: '',
      redirectTo: 'profile',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {
}
